/** Formats raw input into (0XX) XX XX XX style as user types */
export function formatPhoneAM(raw: string): string {
    const digits = raw.replace(/\D/g, '').slice(0, 9);
    if (digits.length === 0) return '';
    if (digits.length <= 3) return `(${digits}`;
    if (digits.length <= 5) return `(${digits.slice(0,3)}) ${digits.slice(3)}`;
    if (digits.length <= 7) return `(${digits.slice(0,3)}) ${digits.slice(3,5)} ${digits.slice(5)}`;
    return `(${digits.slice(0,3)}) ${digits.slice(3,5)} ${digits.slice(5,7)} ${digits.slice(7,9)}`;
}

/** Strips formatting, returns only digits */
export function rawPhone(formatted: string): string {
    return formatted.replace(/\D/g, '');
}
